import { render, staticRenderFns } from "./JobDetailed.vue?vue&type=template&id=228d0cc8&scoped=true"
import script from "./JobDetailed.vue?vue&type=script&lang=ts"
export * from "./JobDetailed.vue?vue&type=script&lang=ts"
import style0 from "./JobDetailed.scss?vue&type=style&index=0&id=228d0cc8&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228d0cc8",
  null
  
)

export default component.exports